module.exports = __webpack_public_path__ + "static/media/about_sec2.494f8c6c.png";